import { createActions } from 'redux-actions'

export const { addClass, selectClass, toggleClass, toggleClassInMyTimetable } = createActions({
  ADD_CLASS: (classData) => classData,
  SELECT_CLASS: (name) => name,
  TOGGLE_CLASS: (day, index) => ({ day, index }),
  TOGGLE_CLASS_IN_MY_TIMETABLE: (day, index) => ({ day, index }),
})
